import momentJalaali from "moment-jalali";
import { useState, useRef, Fragment, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CartPlus, Receipt, PlusCircle, ExclamationTriangle, List } from 'react-bootstrap-icons';
import { Alert, Button, Col } from 'react-bootstrap';
import NewNumberInput from '../../../Components/NewNumberInput';
import { setDialog } from "../../store/api/GetAllProduct";
import { saveServiceInvoice, saveUsedProduct, deleteServiceUsedPart, getserviceUsedParts } from "../../store/api/Services";
import ModalProductRequestFromService from "./ModalProductRequest";
import DatePicker from "react-datepicker2";
import { isMobileApp, isWebApp } from "../../../store/api/CommonFunctions";
import BihamtaTable from "../../../Components/BihamtaTable";
import ModalGuaranteeSubProducts from "../ModalGuaranteeSubProducts";
import ModalInvoiceSerials from "../../../Sale/Components/ModalInvoiceSerials";
function ServiceUsedParts(props) {
    const { serviceInfo, setServiceInfo, setProductPopup } = props;
    const { settings, serviceUsedParts, fieldList } = useSelector(state => {
        return {
            settings: state.SystemSettingsReducer.systemSettings,
            serviceUsedParts: state.service.serviceUsedParts ?? [],
            fieldList: state.UserReducer.pageFieldList,
        }
    });
    const [isPending, setPending] = useState(false);
    const [submitErr, setSubmitErr] = useState(null);
    const [selectedUsedPart, selectUsedPart] = useState({});
    const [popSerials, setPopSerials] = useState({ show: false });
    const [modalProductRequest, setModalProductRequest] = useState({ show: false });
    const usedPartsList = Array.isArray(serviceUsedParts) ? { Data: serviceUsedParts } : serviceUsedParts;
    const defaultReduceStorage = settings?.find(s => s.SettingName === "Services_ReduceFromStorage")?.SettingValue.toLowerCase() === "true";
    const productGrouppingType = Array.isArray(settings) ? Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue ?? 1) : 1;
    const [priceValues, setPriceValues] = useState({ TaxAmount: 0, PureTotalPrice: 0, Discount: 0, UnitPrice: 0, ProductCount: 1 });
    const dispatch = useDispatch();
    const [isGuarantee, setIsGuarantee] = useState(false);
    const [isSwap, setIsSwap] = useState(false);
    const [gDates, setGDates] = useState({});
    const suppliedByStaff = useRef(false);
    const [selectedSub, setSelectedSub] = useState();
    const [modalSubProducts, setModalSubProducts] = useState({ show: false });
    const showStaffShare = !(Number(serviceInfo.AgencyID > 0) && serviceInfo.ReceptionInAgent.toString().toLowerCase() === "true");
    const checkFieldPermission = useCallback((fieldName, actionType) => {
        let result = actionType === "Read";
        let field = fieldList?.find(f => f.PageName === "Service_UsedPart" && f.Name === fieldName);
        if (actionType === "Read" && field) {
            result = field.IsRead === true;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false;
        }
        return result;
    });
    const tableCols = [
        { colTitle: "مشخصات قطعه", colName: "ProductCode+ProductName+ProductModel", colType: "string", showInMobile: true },
        { colTitle: "نام انبار", colName: "StorageName", showInMobile: true },
        { colTitle: "تعداد", colName: "ProductCount" },
        { colTitle: "قیمت خرید", colName: checkFieldPermission("UnitPrice", "Read") ? "PurchasePrice" : "", colType: "currency" },
        { colTitle: "قیمت واحد", colName: checkFieldPermission("UnitPrice", "Read") ? "UnitPrice" : "", colType: "currency" },
        { colTitle: "تخفیف", colName: checkFieldPermission("Discount", "Read") ? "Discount" : "", colType: "currency" },
        { colTitle: "مالیات", colName: checkFieldPermission("UnitPrice", "Read") ? "TaxAmount" : "", colType: "currency" },
        { colTitle: "قابل پرداخت", colName: checkFieldPermission("UnitPrice", "Read") ? "PureTotalPrice" : "", colType: "currency" },
        { colTitle: "گارانتی", colName: "IsGuaranty", colType: "boolean", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "شماره سریال", colName: "SerialNumber", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "آغاز گارانتی", colName: "PGuaranteeStartDate" },
        { colTitle: "پایان گارانتی", colName: "PGuaranteeEndDate" },
        { colTitle: "سهم تکنسین", colName: checkFieldPermission("StaffShare", "Read") ? "StaffShare" : "", colType: "currency", showCondition: () => showStaffShare },
        { colTitle: "تهیه شده توسط تکنسین", colName: "SuppliedByStaff", colType: "boolean" },
        { colTitle: "کسر از انبار", colName: "ReduceFromStorage", colType: "boolean" }
    ]
    const rowButtons = [
        {
            type: "delete", title: "حذف", className: "rowBtn", onclick: (item) => {
                if (serviceInfo?.IsArchive !== true && !serviceInfo.IsNotLastDuration && !serviceInfo.StoppedInStatus) {
                    dispatch(setDialog({
                        status: 'show',
                        arrayBtn: ['yes', 'no'],
                        dialogTitle: 'حذف قطعه مصرفی',
                        dialogText: 'آیا از حذف مطمئن هستید؟',
                        okOperation: deleteServiceUsedPart(item.ID, onDelete)
                    }))
                }
            }
        }
    ]
    const partRequest = () => {
        //        history.push("/Services/PartRequest/0");
        setModalProductRequest({
            show: true,
            CustomerID: serviceInfo.CustomerID,
            ServiceID: serviceInfo.ServiceID,
            ServiceType: serviceInfo.ServiceType,
            ProductID: serviceInfo.ProductID,
            ProductSerial: serviceInfo.SerialNumber,
            StaffID: serviceInfo.StaffID,
            ServiceAddress: serviceInfo.ServiceAddress,
            ServiceNumber: serviceInfo.InvoiceNumber

        })
    }

    function addMonth(month) {
        if (gDates.StartDate && gDates.StartDate !== '') {
            const m = momentJalaali(gDates.StartDate);
            const endDt = m.add("jMonth", Number(month));
            gDates.GuaranteeTimeInMonth = month;
            setGDates({ ...gDates, EndDate: endDt.local("en").format("YYYY-MM-DD") });

        }
    }
    function calcG_TimeInMonth(date, isEnd) {
        if (isEnd) {
            gDates.EndDate = date;
        }
        else {
            gDates.StartDate = date;
        }
        const gStartDate = gDates.StartDate;
        const gEndDate = gDates.EndDate;
        if ((isEnd && (!gStartDate || gStartDate === '')) || (!isEnd && (!gEndDate || gEndDate === ''))) {
            return;
        }
        const endDate = isEnd ? new Date(date) : new Date(gEndDate);
        const startDate = isEnd ? new Date(gStartDate) : new Date(date);
        let months = endDate.getMonth() - startDate.getMonth()
            + (12 * (endDate.getFullYear() - startDate.getFullYear()));

        if (endDate.getDate() < startDate.getDate()) {
            months--;
        }
        setGDates({ ...gDates, GuaranteeTimeInMonth: months });

    }

    // function toCurrency(name, value) {
    //     let el = document.getElementById("comma_" + name);
    //     el.setAttribute("comma-value", Number(value).toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
    // }
    function saveInvoice() {
        setSubmitErr(null);
        if (!serviceUsedParts || serviceUsedParts === "" || serviceUsedParts.length === 0) {
            setSubmitErr("قطعه ای ثبت نشده است");
            return;
        }

        dispatch(saveServiceInvoice(serviceInfo?.ServiceType, serviceInfo?.ServiceID));
    }

    function saveUsedPart() {
        if(isPending)
        {
            return;
        }
        let usedPartData = {};
        setSubmitErr(null);
        document.querySelectorAll("[usedpartdata]").forEach(el => { usedPartData[el.name] = (el.type === "checkbox" ? el.checked : el.value); });
        if ((usedPartData.ProductName ?? "") === "") {
            setSubmitErr("قطعه ای انتخاب نشده است");
            return;
        }
        if (isSwap && !selectedSub?.ProductID) {
            setSubmitErr("قطعه ای برای تعویض انتخاب نشده است");
            return;
        }
        if (isSwap && !(usedPartData.SerialNumber?.length > 0)) {
            setSubmitErr("وارد کردن سریال هنگام تعویض الزامی است");
            return;
        }
        // if (isSwap && (!gDates.StartDate || !gDates.EndDate)) {
        //     setSubmitErr("وارد کردن تاریخ گارانتی هنگام تعویض الزامی است");
        //     return;
        // }
        if (!usedPartData.UnitPrice) {
            usedPartData.UnitPrice = 0;
        }
        //برای قطعه متفرقه کسر ازا نبار معنایی ندارد
        if (!(Number(usedPartData.ProductID) > 0)) {
            usedPartData.ReduceFromStorage = false;
        }
        if (!usedPartData.ProductCount) {
            usedPartData.ProductCount = 1;
        }
        usedPartData.ServiceID = serviceInfo?.ServiceID;
        usedPartData.ServiceType = serviceInfo?.ServiceType;
        usedPartData.GuaranteeStartDate = gDates.StartDate;
        usedPartData.GuaranteeEndDate = gDates.EndDate;
        usedPartData.ProductName = selectedUsedPart.ProductName;
        usedPartData.ProductModel = selectedUsedPart.ProductModel;
        usedPartData.SuppliedByStaff = suppliedByStaff.current;
        const onSuccess = (res) => {
            serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
            serviceInfo.AmountMainCompanyPays = res.AmountMainCompanyPays;
            serviceInfo.TaxAmount = res.TaxAmount;
            serviceInfo.Discount = res.Discount;
            setPending(false);
            setGDates({});
            setServiceInfo({ ...serviceInfo });
            selectUsedPart({});
            setSelectedSub();
            const elSerial = document.getElementById("PartSerialNumber");
            if (elSerial) {
                elSerial.value = "";
            }
            setPriceValues({ TaxAmount: 0, PureTotalPrice: 0, Discount: 0, UnitPrice: 0, ProductCount: 1 });
        }
        setPending(true);
        const onError = ()=>{
            setPending(false);
        }
        dispatch(saveUsedProduct(usedPartData, onSuccess, usedPartsList, onError));
    }
    function onDelete(res) {
        serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
        serviceInfo.AmountMainCompanyPays = res.AmountMainCompanyPays;
        serviceInfo.TaxAmount = res.TaxAmount;
        serviceInfo.Discount = res.Discount;
    }
    function showModalProductsForBorrow(e) {
        // const setUp = async (up)=> {
        //     selectUsedPart(up)
        // };
        const onSelect = (up) => {
            e.target.value = "";
            selectUsedPart(up??{});
            if (up) {
                //toCurrency("UnitPrice", up.UnitPrice);
                up.FirstCount = up.SuggestedCount;
                priceValues.PurchasePrice = up.PurchasePrice;
                Object.assign(selectedUsedPart, up);
                //برای اینکه بتوان از اختصاص یافتن قطعه مصرفی پیش از فراخوانی تابع زیر اطمینان حاصل کرد
                //باید از خط کد بالا استفاده کنیم
                onPriceChanged("UnitPrice", up.UnitPrice);
            }
        }
        if (e.target.value === "borrow") {
            setProductPopup({
                show: true,
                searchForBorrowUsedParts: true,
                staffID: serviceInfo?.StaffID,
                staffName: serviceInfo?.StaffName,
                setProductData: onSelect
            })
        }
        else if (e.target.value === "storage") {
            setProductPopup({
                show: true, searchParts: true,
                isGuarantee: isGuarantee ?? false,
                mainProductHardCode: serviceInfo?.ProductHardCode,
                setProductData: onSelect
            });
        }
    }
    function onPriceChanged(name, value) {
        if (!value || value === "") {
            value = 0;
        }
        priceValues[name] = Number(value);
        if (name === "ProductCount") {
            if (selectedUsedPart?.FirstCount && Number(selectedUsedPart?.InvoiceDetailID) > 0) {
                if (Number(value) > Number(selectedUsedPart.FirstCount)) {
                    value = selectedUsedPart.FirstCount;
                }
            }
            if (selectedUsedPart) {
                selectedUsedPart.SuggestedCount = Number(value);
            }
        }
        if (name === "UnitPrice") {
            if (selectedUsedPart) {
                selectedUsedPart.UnitPrice = Number(value);
            }
        }
        if (name === "PurchasePrice") {
            if (selectedUsedPart) {
                selectedUsedPart.PurchasePrice = Number(value);
            }
        }
        if (!priceValues.ProductCount) {
            priceValues.ProductCount = 0;
        }
        if (!priceValues.Discount) {
            priceValues.Discount = 0;
        }
        if (!priceValues.TaxPercent) {
            priceValues.TaxPercent = 0;
        }
        if (!priceValues.UnitPrice) {
            priceValues.UnitPrice = 0;
        }
        if (!priceValues.PurchasePrice) {
            priceValues.PurchasePrice = 0;
        }
        priceValues.TaxAmount = (priceValues.UnitPrice * priceValues.ProductCount - priceValues.Discount) * priceValues.TaxPercent / 100;
        priceValues.PureTotalPrice = priceValues.UnitPrice * priceValues.ProductCount - priceValues.Discount + priceValues.TaxAmount;
        priceValues.Profit = priceValues.UnitPrice * priceValues.ProductCount - priceValues.Discount - (priceValues.PurchasePrice * priceValues.ProductCount);
        if (name !== "StaffShare" && !isGuarantee && showStaffShare) {
            if (Number(selectedUsedPart.ProductID) > 0) {
                priceValues.StaffShare = priceValues.Profit * Number(serviceInfo.StaffUsedPartsCostPercentShare) / 100 + Number(serviceInfo.StaffUsedPartsCostFixAmountShare);
            }
            else {
                priceValues.StaffShare = priceValues.Profit * Number(serviceInfo.StaffExtraUsedPartsCostPercentShare) / 100 + Number(serviceInfo.StaffExtraUsedPartsCostFixAmountShare);
                if (suppliedByStaff.current) {
                    priceValues.StaffShare += priceValues.PurchasePrice * priceValues.ProductCount;
                }
            }
        }

        setPriceValues({ ...priceValues })
    }
    function onInputFocus(e) {
        e.target.select();
    }
    function onChangeProductNameOrSerial(e) {
        if (!selectedUsedPart) {
            selectedUsedPart = {};
        }
        selectedUsedPart[e.target.name] = e.target.value;
        selectUsedPart({ ...selectedUsedPart });
    }

    function showModalSubProduct() {
        setModalSubProducts({
            show: true,
            cardNo: serviceInfo.GuarantyCode,
            serialNumber: serviceInfo.SerialNumber,
            productName: serviceInfo.ProductName,
            productModel: serviceInfo.ProductModel,
            onSelect: setSelectedSub
        })
    }
    function showModalSerials() {
        const setData = (data) => {
            if (data) {
                data.SuggestedCount = 1;
                data.ProductCount = 1;
                data.SerialNumber = data.ProductSerial;
                Object.assign(selectedUsedPart, data);
                priceValues.ProductCount = 1;
                priceValues.PureTotalPrice = priceValues.TotalPrice = priceValues.UnitPrice = Number(data.UnitPrice);
                setPriceValues({ ...priceValues });
            }
        }
        setPopSerials({
            show: true,
            filterFaulty: false,
            setData: setData
        })
    }

    useEffect(() => {
        // let loadUsedParts = false;
        // if(serviceUsedParts && serviceUsedParts.length > 0)
        // {
        //     loadUsedParts =  serviceUsedParts.some(u=>Number(u.ServiceID) === Number(serviceInfo?.ServiceID) && u.ServiceType === serviceInfo?.ServiceType);
        // }
        if (Number(serviceInfo?.ServiceID) > 0 /*&& !loadUsedParts*/)
            dispatch(getserviceUsedParts(serviceInfo?.ServiceID, serviceInfo?.ServiceType));

    }, [])

    return (
        <Fragment>
            <ModalInvoiceSerials popData={popSerials} setPopData={setPopSerials} productGrouppingType={productGrouppingType} />
            <ModalProductRequestFromService popData={modalProductRequest} setPopData={setModalProductRequest} />
            {isSwap && <ModalGuaranteeSubProducts popData={modalSubProducts} setPopData={setModalSubProducts} />}
            {submitErr &&
                <Alert variant="danger">
                    <ExclamationTriangle size={18} />&nbsp;
                    {submitErr}
                </Alert>
            }
            {serviceInfo?.IsArchive !== true && !serviceInfo?.IsNotLastDuration &&
                <Fragment>
                    <input type="checkbox" className="form-check-input mt-0" name="IsGuaranty" usedpartdata="" onChange={e => setIsGuarantee(e.target.checked)} /><span style={{ color: "#d40f6a", marginTop: "3px" }}>  قطعه گارانتی است&nbsp;&nbsp;</span>
                    <input type="checkbox" className="form-check-input mt-0" name="ReduceFromStorage" usedpartdata="" defaultChecked={defaultReduceStorage} readOnly /><span style={{ color: "#d40f6a" }}>  از انبار کسر شود</span>&nbsp;
                    <input type="checkbox" className="form-check-input mt-0" onChange={e => setIsSwap(e.target.checked)} /><span style={{ color: "#4a22c5" }}>  قطعه تعویضی است</span>&nbsp;
                    {!(Number(selectedUsedPart?.ProductID) > 0) && <Fragment> <input type="checkbox" className="form-check-input mt-0" name="SuppliedByStaff" usedpartdata="" onChange={e => suppliedByStaff.current = e.target.checked} /><span style={{ color: "#4a22c5" }}>  تکنسین تهیه کرده است</span></Fragment>}
                    {isMobileApp() && <div className="row" style={{ margin: 0 }}>
                        {
                            isSwap &&
                            <Fragment>
                                <Col md={2} style={{ margin: 0, padding: 2 }}>
                                    <label className="ellipsisLabel" title="مشخصات قطعه قدیمی">مشخصات قطعه قدیمی</label>
                                    <input type="hidden" name="SwappedProductID" value={selectedSub?.ProductID ?? 0} usedpartdata="" readOnly />
                                    <input className="tableRowInput" value={(selectedSub?.ProductName ?? "") + (selectedSub?.ProductModel ? (" " + selectedSub?.ProductModel) : "")} readOnly />
                                    <Button className="btn-input-tiny" style={{ top: "23px", left: "4px" }} onClick={showModalSubProduct}><List size={19} /></Button>
                                </Col>
                                <Col md={2} style={{ margin: 0, padding: 2 }}>
                                    <label className="ellipsisLabel">سریال قطعه قدیمی</label>
                                    <input className="tableRowInput" value={selectedSub?.SerialNumber} name="SwappedSerialNumber" usedpartdata="" readOnly style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                </Col>
                            </Fragment>
                        }
                        <Col md={3} style={{ margin: 0, padding: 2 }}>
                            <label className="ellipsisLabel">مشخصات قطعه {isSwap && ' جدید'}</label>
                            <input type='hidden' name='InvoiceDetailID' defaultValue={selectedUsedPart?.InvoiceDetailID ?? 0} usedpartdata="" />
                            <input type='hidden' name='StorageID' defaultValue={selectedUsedPart?.StorageID ?? 0} usedpartdata="" />
                            <input type="hidden" name="ProductID" defaultValue={selectedUsedPart?.ProductID ?? 0} usedpartdata="" />
                            <input className="tableRowInput" name="ProductName" usedpartdata=""
                                value={(selectedUsedPart?.ProductCode ?? "")+(selectedUsedPart?.ProductName ?? "") + (selectedUsedPart?.ProductModel ? (" " + selectedUsedPart?.ProductModel) : "")} onChange={onChangeProductNameOrSerial} />
                            <select className="btn btn-block btn-input-tiny  btn-secondary selectBtn" onChange={showModalProductsForBorrow} style={{ width: "55px", top: "23px", left: "5px" }}>
                                <option value="">انتخاب از</option>
                                <option value="storage">انبار</option>
                                <option value="borrow">حـواله</option>
                            </select>
                        </Col>
                        {/* {(isGuarantee || isSwap) && */}
                        <Col md={2} style={{ margin: 0, padding: 2 }}>
                            <label>سریال قطعه {isSwap && ' جدید'}</label>
                            <input className="tableRowInput" id="PartSerialNumber" name="SerialNumber" usedpartdata="" style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} value={selectedUsedPart?.SerialNumber ?? ""} onChange={onChangeProductNameOrSerial} />
                            <Button className="btn-input-tiny" onClick={showModalSerials} style={{ top: "23px", left: "5px" }}><List size={17} /></Button>
                        </Col>
                        {/* } */}
                        {isGuarantee &&
                            <Fragment>
                                <Col md={1} style={{ margin: 0, padding: 2 }}>
                                    <label className="ellipsisLabel">آغاز گارانتی</label>
                                    <DatePicker className="tableRowInput mt-0" isGregorian={false} timePicker={false} value={gDates.StartDate ? momentJalaali(gDates.StartDate) : null} onChange={value => { setGDates({ ...gDates, StartDate: value.local("en").format("YYYY-MM-DD") }) }} />
                                </Col>
                                <Col md={1} style={{ margin: 0, padding: 2 }}>
                                    <label className="ellipsisLabel">مدت گارانتی</label>
                                    <input className="tableRowInput" type="number" onChange={e => addMonth(e.target.value)} value={gDates.GuaranteeTimeInMonth ?? ""} />
                                </Col>
                                <Col md={1} style={{ margin: 0, padding: 2 }}>
                                    <label className="ellipsisLabel">پایان گارانتی</label>
                                    <DatePicker className="tableRowInput mt-0" isGregorian={false} timePicker={false} value={gDates.EndDate ? momentJalaali(gDates.EndDate) : null} onChange={val => { calcG_TimeInMonth(val.local("en").format("YYYY-MM-DD"), true) }} />
                                </Col>
                            </Fragment>
                        }
                        <Col md={1} style={{ margin: 0, padding: 2 }}>
                            <label>تعداد</label><span style={{ color: "red" }}>*</span>
                            <input className="tableRowInput" type="number" name="ProductCount" value={selectedUsedPart?.SuggestedCount ?? 1} min={1}
                                onChange={e => onPriceChanged("ProductCount", e.target.value)} usedpartdata="" onFocus={onInputFocus} />
                        </Col>
                        <div className="col-md-2" style={{ margin: 0, padding: 2 }}>
                            <label>قیمت خرید</label>
                            <NewNumberInput className="tableRowInput" inputname="PurchasePrice" readonly={Number(selectedUsedPart?.InvoiceDetailID) > 0} value={selectedUsedPart?.PurchasePrice ?? 0} onChange={e => { onPriceChanged("PurchasePrice", e.target.value) }} minvalue={0} customattr={{ usedpartdata: '' }} />
                        </div>
                        <div className="col-md-2" style={{ margin: 0, padding: 2 }}>
                            <label>قیمت فروش</label>
                            <NewNumberInput className="tableRowInput" inputname="UnitPrice" /*readonly={Number(selectedUsedPart?.InvoiceDetailID) > 0}*/ value={selectedUsedPart?.UnitPrice ?? 0} onChange={e => { onPriceChanged("UnitPrice", e.target.value) }} minvalue={0} customattr={{ usedpartdata: '' }} />
                        </div>
                        <div className="col-md-2" style={{ margin: 0, padding: 2 }}>
                            <label>تخفیف</label>
                            <NewNumberInput className="tableRowInput" inputname="Discount" defaultValue={0} minvalue={0} customattr={{ usedpartdata: "" }} onChange={e => onPriceChanged("Discount", e.target.value)} />
                        </div>
                        <Col md={2} style={{ margin: 0, padding: 2 }}>
                            <div style={{ width: "30%", display: "inline-block" }}>
                                <label className='ellipsisLabel' title='درصد مالیات'>% مالیات</label>
                                <input className="tableRowInput" type='number' defaultValue={0} name="TaxPercent" onFocus={onInputFocus}
                                    usedpartdata="" onChange={(e) => onPriceChanged("TaxPercent", e.target.value)} minvalue={0} style={{ borderRadius: "0px 4px 4px 0px" }} />
                            </div>
                            <div style={{ width: "70%", display: "inline-block" }}>
                                <label>مالیات</label>
                                <NewNumberInput className="tableRowInput" inputname="TaxAmount" readonly={true} value={priceValues.TaxAmount} style={{ borderRadius: "4px 0px 0px 4px", marginRight: "1px" }}
                                    customattr={{ usedpartdata: "" }} />
                            </div>
                        </Col>
                        <Col md={2} style={{ margin: 0, padding: 2 }}>
                            <label>قابل پرداخت: </label>
                            <NewNumberInput className="tableRowInput" readonly={true} value={priceValues.PureTotalPrice} />
                        </Col>
                        {showStaffShare &&
                            <Col md={2} style={{ margin: 0, padding: 2 }}>
                                <label>سهم تکنسین: </label>
                                <NewNumberInput className="tableRowInput" value={priceValues.StaffShare} inputname="StaffShare" customattr={{ usedpartdata: '' }} onChange={e => onPriceChanged("StaffShare", e.target.value)} />
                            </Col>
                        }
                    </div>}

                    {isWebApp() &&
                        <table style={{ whiteSpace: "nowrap", width: "100%" }} className="mt-1">
                            <thead style={{ fontSize: "12px" }}>
                                <tr style={{ fontSize: "11.5px" }}>
                                    {isSwap &&
                                        <Fragment>
                                            <th>مشخصات قطعه قدیمی:</th>
                                            <th>سریال قطعه قدیمی:</th>
                                        </Fragment>
                                    }
                                    <th style={{ width: "250px" }}>مشخصات قطعه: {isSwap && ' جدید'}</th>
                                    {/*{(isGuarantee || isSwap) &&*/} <th style={{ width: "150px" }}>سریال قطعه:</th>{/*}}*/}
                                    {isGuarantee &&
                                        <Fragment>
                                            <th style={{ width: "110px" }}>آغاز گارانتی:</th>
                                            <th style={{ width: "80px" }}>مدت گارانتی:</th>
                                            <th style={{ width: "110px" }}>پایان گارانتی:</th>
                                        </Fragment>}
                                    <th style={{ width: "50px" }}>تعداد:</th>
                                    <th>قیمت خرید:</th>
                                    <th>قیمت فروش:</th>
                                    <th>تخفیف:</th>
                                    <th style={{ width: "150px" }}>مالیات:</th>
                                    <th>قابل پرداخت:</th>
                                    {showStaffShare && <th>سهم تکنسین:</th>}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {isSwap &&
                                        <Fragment>
                                            <td>
                                                <div>
                                                    <input type="hidden" name="SwappedProductID" value={selectedSub?.ProductID ?? 0} usedpartdata="" readOnly />
                                                    <input className="tableRowInput" value={(selectedSub?.ProductName ?? "") + (selectedSub?.ProductModel ? (" " + selectedSub?.ProductModel) : "")} readOnly />
                                                    <Button className="btn-input-tiny" onClick={showModalSubProduct} style={{ top: "1px", left: "2px" }}><List size={19} /></Button>
                                                </div>
                                            </td>
                                            <td>
                                                <input className="tableRowInput" value={selectedSub?.SerialNumber} name="SwappedSerialNumber" usedpartdata="" readOnly style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                            </td>
                                        </Fragment>
                                    }
                                    <td>
                                        <div>
                                            <input type='hidden' name='InvoiceDetailID' defaultValue={selectedUsedPart?.InvoiceDetailID ?? 0} usedpartdata="" />
                                            <input type='hidden' name='StorageID' defaultValue={selectedUsedPart?.StorageID ?? 0} usedpartdata="" />
                                            <input type="hidden" name="ProductID" defaultValue={selectedUsedPart?.ProductID ?? 0} usedpartdata="" />
                                            <input type="text" className="tableRowInput" name="ProductName" usedpartdata=""
                                                value={(selectedUsedPart?.ProductCode ?? "") + (selectedUsedPart?.ProductName ?? "") + (selectedUsedPart?.ProductModel ? (" " + selectedUsedPart?.ProductModel) : "")} onChange={onChangeProductNameOrSerial} />
                                            <select className="btn btn-block btn-input-tiny btn-secondary selectBtn" onChange={showModalProductsForBorrow} style={{ width: "55px", top: "2px", left: "2px", padding: 0 }}>
                                                <option value="">انتخاب از</option>
                                                <option value="storage">انبار</option>
                                                <option value="borrow">حـواله</option>
                                            </select>
                                        </div>
                                    </td>
                                    {/* {(isGuarantee || isSwap) && */}
                                    <td>
                                        <div>
                                            <input className="tableRowInput" id="PartSerialNumber" name="SerialNumber" usedpartdata="" style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} value={selectedUsedPart?.SerialNumber ?? ""} onChange={onChangeProductNameOrSerial} />
                                            <Button className="btn-input-tiny" onClick={showModalSerials} style={{ left: 2, top: 2 }}><List size={17} /></Button>
                                        </div>
                                    </td>
                                    {/* } */}
                                    {isGuarantee &&
                                        <Fragment>
                                            <td>
                                                <DatePicker className="tableRowInput mt-0" isGregorian={false} timePicker={false} value={gDates.StartDate ? momentJalaali(gDates.StartDate) : null} onChange={value => { setGDates({ ...gDates, StartDate: value.local("en").format("YYYY-MM-DD") }) }} />
                                            </td>
                                            <td>
                                                <input className="tableRowInput" type="number" onChange={e => addMonth(e.target.value)} value={gDates.GuaranteeTimeInMonth ?? ""} />
                                            </td>
                                            <td>
                                                <DatePicker className="tableRowInput mt-0" isGregorian={false} timePicker={false} value={gDates.EndDate ? momentJalaali(gDates.EndDate) : null} onChange={val => { calcG_TimeInMonth(val.local("en").format("YYYY-MM-DD"), true) }} />
                                            </td>
                                        </Fragment>
                                    }
                                    <td>
                                        <input className="tableRowInput" type="number" name="ProductCount" value={selectedUsedPart?.SuggestedCount ?? 1} min={1}
                                            onChange={e => onPriceChanged("ProductCount", e.target.value)} usedpartdata="" onFocus={onInputFocus} />
                                    </td>
                                    <td>
                                        <NewNumberInput className="tableRowInput" inputname="PurchasePrice" readonly={Number(selectedUsedPart?.InvoiceDetailID) > 0} value={selectedUsedPart?.PurchasePrice ?? 0} onChange={e => { onPriceChanged("PurchasePrice", e.target.value) }} minvalue={0} customattr={{ usedpartdata: '' }} />
                                    </td>
                                    <td>
                                        <NewNumberInput className="tableRowInput" inputname="UnitPrice" /*readonly={Number(selectedUsedPart?.InvoiceDetailID) > 0}*/ value={selectedUsedPart?.UnitPrice ?? 0} onChange={e => { onPriceChanged("UnitPrice", e.target.value) }} minvalue={0} customattr={{ usedpartdata: '' }} />
                                    </td>
                                    <td>
                                        <NewNumberInput className="tableRowInput" inputname="Discount" defaultValue={0} minvalue={0} customattr={{ usedpartdata: "" }} onChange={e => onPriceChanged("Discount", e.target.value)} />
                                    </td>
                                    <td>
                                        <div style={{ position: "relative", display: "inline-block", width: "30%" }}>
                                            <input className="tableRowInput" type='number' defaultValue={0} name="TaxPercent" onFocus={onInputFocus}
                                                usedpartdata="" onChange={(e) => onPriceChanged("TaxPercent", e.target.value)} minvalue={0} style={{ borderRadius: "0px 4px 4px 0px" }} />
                                        </div>
                                        <NewNumberInput className="tableRowInput" inputname="TaxAmount" readonly={true} value={priceValues.TaxAmount} style={{ borderRadius: "4px 0px 0px 4px", marginRight: "1px" }}
                                            containerStyle={{ width: "70%", display: "inline-block" }} customattr={{ usedpartdata: "" }} />
                                    </td>
                                    <td>
                                        <NewNumberInput className="tableRowInput" readonly={true} value={priceValues.PureTotalPrice} />
                                    </td>
                                    {showStaffShare &&
                                        <td>
                                            <NewNumberInput className="tableRowInput" value={priceValues.StaffShare} inputname="StaffShare" customattr={{ usedpartdata: '' }} onChange={e => onPriceChanged("StaffShare", e.target.value)} />
                                        </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    }
                    <div className="mt-1">
                        <Button variant="success" className="group-Btn" onClick={saveUsedPart} disabled={isPending || serviceInfo.StoppedInStatus}><PlusCircle size={19} />&nbsp;افزودن قطعه</Button>
                    </div>
                </Fragment>
            }
            <BihamtaTable columns={tableCols} rowButtons={rowButtons} dataList={usedPartsList} />
            {serviceInfo?.IsArchive !== true && !serviceInfo?.IsNotLastDuration &&
                <div className="row mt-1">
                    <div >
                        {settings?.find(s => s.SettingName === "Services_AutoInvoiceForUsedparts")?.SettingValue.toLowerCase() === "false" &&
                            <button className="btn btn-block btn-primary group-Btn" onClick={saveInvoice}><Receipt size={20} /> تایید نهایی فاکتور </button>}
                        <Button className="group-Btn" variant="info" onClick={partRequest}><CartPlus size={20} /> درخواست قطعه </Button>
                    </div>
                </div>
            }

        </Fragment>
    )
}
export default ServiceUsedParts;